import { Outlet, useLocation } from "react-router-dom"
import { useEffect } from "react"
import { useHead } from "@unhead/react"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import { pageCanonical } from "@/lib/seo"

function Layout() {
  const location = useLocation()

  useHead({
    link: [
      {
        key: "canonical",
        rel: "canonical",
        href: pageCanonical(location.pathname),
      },
    ],
  })

  useEffect(() => {
    if (location.hash) {
      const target = document.getElementById(location.hash.slice(1))
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" })
        return
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior })
  }, [location.pathname, location.hash])

  return (
    <div className="min-h-screen bg-[#f4eee6] text-stone-800">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default Layout
